// The one way a customer reaches the kennel, and the only messaging channel
// this product has (§9: no email provider, no third-party messaging).
//
// Every dead end on the customer side leads here rather than to a support form
// nobody reads: a link that expired, an account already in use, a link somebody
// else finished on. The desk lives in WhatsApp already, which is exactly why
// the portal never pretends to send anything itself.
//
// THE NUMBER IS THE KENNEL'S, hard-coded here for the same reason the brand
// name is: it is one fact, it belongs to the business rather than to a
// household, and a settings key nobody has built a screen for would be a lie
// about how configurable it is. `availability-and-request` opens Settings ›
// Customer portal, and it moves there when it does.
const PATRICIA_WHATSAPP = '353862345462'; // 086 234 5462 (Freddi, 2026-10-09)

const OPENER = 'Hi Patricia, ';

/**
 * THE PLAIN DOOR OPENS HER THREAD AND TYPES NOTHING (Freddi, 2026-10-09): the
 * customer lands in the conversation they already have with her, not on a
 * greeting they did not write. Only a door that stands in for a row not yet
 * built — Transfer, Upload — types a line, through `whatsappHref`, because
 * that line is how she learns which thing was tapped.
 */
export const WHATSAPP_HREF = `https://wa.me/${PATRICIA_WHATSAPP}`;

/** The same door, with the customer's own opening line already typed. */
export function whatsappHref(text: string): string {
  return `https://wa.me/${PATRICIA_WHATSAPP}?text=${encodeURIComponent(OPENER + text)}`;
}
